export const IN_PAGE_MENU = 'in-page-menu';
export const IS_SHOW_CLUB_SEARCH = 'isShowClubSearch';
export const POSITION_OFFSET_FROM_TOP_DESKTOP = 68.8;
export const POSITION_OFFSET_FROM_TOP_MOBILE = 56;
export const POSITION_FOR_LOGGED_IN_OFFSET_FROM_TOP_DESKTOP = 57.8;
export const DOWNLOAD_APP_HEIGHT = 80;
export const TABBED_HEADER_HEIGHT_DESKTOP = 48;
export const TABBED_HEADER_HEIGHT_MOBILE = 40;
